export default {
	USDT: 'USDT',
	保存并下次使用: '儲存以供下次使用',
	保存此卡以用于后续支付: '保存此卡以用於後續支付',
	操作: '操作',
	操作失败: '操作失敗',
	操作时间: '操作時間',
	查看发票: '查看發票',
	查看记录: '查看記錄',
	查看信用发票: '查看信用發票',
	查看信用记录: '查看信用記錄',
	持卡人姓名: '持卡人姓名',
	充值记录: '充值記錄',
	充值金额: '充值金額',
	充值提示: '請輸入 {min}～{max} 範圍的整數',
	创建时间: '創建時間',
	打印: '列印',
	打印时间: '列印時間',
	到期: '到期',
	到期日期: '到期日期',
	订单编号: '訂單編號',
	订单发票: '訂單發票',
	订单详情: '訂單詳情',
	订单支付: '訂單支付',
	发票编号: '發票編號',
	发票项目: '發票項目',
	发票PDF: '發票PDF',
	非常感谢您的付款已成功完成: '非常感謝，您的付款已成功完成',
	复制链接: '複製連結',
	复制失败: '複製失敗',
	管理信用卡: '管理信用卡',
	交易详情: '交易詳情',
	接收方: '接收方',
	金额: '金額',
	金额已复制: '金額已複製',
	进行实名认证: '進行實名認證',
	卡片保存成功: '卡片儲存成功',
	可用余额: '可用餘額',
	类型: '類型',
	立即充值: '立即充值',
	链接已复制: '連結已複製',
	登录提醒: '登入提醒',
	描述: '描述',
	默认: '預設',
	内容: '內容',
	其它支付方式: '其他支付方式（支援信用卡、支付寶、微信等）',
	请扫描二维码或点击金额和地址粘贴转账USDT支付: '請掃描二維碼或點擊金額和地址貼上轉賬，USDT(trc-20) 支付。',
	'请使用微信「扫一扫」': '請使用微信「掃一掃」完成付款',
	'请使用支付宝「扫一扫」': '請使用支付宝「掃一掃」完成付款',
	请输入持卡人姓名: '請輸入持卡人姓名',
	请输入发票编号: '請輸入發票編號',
	请先获取支付信息: '請先獲取支付信息',
	请先登录后使用该支付方式: '請先登入後使用該支付方式',
	请先进行实名认证或提升实名认证等级: '請先進行實名認證或提升實名認證等級',
	确认删除此卡吗: '確認刪除此卡嗎？',
	去登录: '去登入',
	删除此卡: '刪除此卡',
	商品名称: '商品名稱',
	设为自动扣款: '設為自動扣款',
	生成日期: '生成日期',
	生成时间: '生成時間',
	实名认证提醒: '實名認證提醒',
	使用浏览器打开支付页面: '使用瀏覽器打開支付頁面',
	使用新卡: '使用新卡',
	使用信用卡: '使用銀行卡',
	使用已保存的卡: '使用已儲存的卡',
	使用已保存的卡片: '使用已保存的卡片',
	输入新卡支付: '輸入新卡支付',
	拖动卡片进行排序: '拖動卡片進行排序',
	微信扫码支付: '請使用微信掃碼完成付款',
	微信支付: '微信支付',
	下载: '下載',
	小计: '小計',
	新增信用卡: '新增信用卡',
	信用发票: '信用發票',
	信用记录: '信用記錄',
	信用卡: '銀行卡',
	信用余额: '信用餘額',
	信用余额可用于后续平台的消费: '信用餘額可用於後續平台的消費',
	选择支付方式: '選擇支付方式',
	已过期: '支付已過期',
	应付金额: '應付金額',
	余额: '餘額',
	余额不足: '餘額不足，請充值或選擇其它支付方式',
	账号概况: '帳號概況',
	正在验证: '驗證中...',
	支付: '支付',
	支付宝: '支付寶',
	支付成功: '支付成功',
	支付初始化失败: '支付初始化失敗',
	支付方式: '支付方式',
	支付金额: '支付金額',
	支付日期: '支付日期',
	支付失败: '支付失敗',
	支付时间: '支付時間',
	支付信息: '支付信息',
	支付中: '支付中...',
	支付ID: '支付ID',
	转账金额必须为下方显示带小数点的金额: '轉賬金額必須為下方顯示帶小數點的金額',
	转账金额必须为下方显示的金额且需要在倒计时内完成转账否则无法被系统确认:
		'轉賬金額必須為下方顯示的金額，且需要在倒計時內完成轉賬，否則無法被系統確認！',
	状态: '狀態',
	自定义: '自定义',
	自动扣款: '自動扣款',
	自动扣款中: '自動扣款中',
	总计: '總計',
	最低充值金额: '最低充值 {amount}',
	USDT地址已复制: 'USDT地址已複製',
}
